import { render, staticRenderFns } from "./unique_tournament.vue?vue&type=template&id=1329e218&"
import script from "./unique_tournament.vue?vue&type=script&lang=js&"
export * from "./unique_tournament.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports